import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './index.css'
import App from './App.tsx'
import { initSentry, SentryErrorBoundary } from './lib/sentry'

// Initialize Sentry before rendering the app
initSentry()

const container = document.getElementById('root')!
const root = createRoot(container)

root.render(
  <StrictMode>
    <SentryErrorBoundary
      fallback={({ error, resetError }) => (
        <div style={{ padding: '20px', textAlign: 'center' }}>
          <h1>Oops! Something went wrong</h1>
          <p>{error instanceof Error ? error.message : 'An unknown error occurred'}</p>
          <button onClick={resetError}>Try again</button>
        </div>
      )}
      showDialog
    >
      <App />
    </SentryErrorBoundary>
  </StrictMode>,
)
